import React from 'react';

interface RubleIconProps {
  style?: React.CSSProperties;
  className?: string;
}

export const RubleIcon: React.FC<RubleIconProps> = ({ style, className }) => {
  return (
    <span 
      role="img" 
      aria-label="ruble"
      className={className}
      style={{
        display: 'inline-block',
        color: 'inherit',
        fontStyle: 'normal',
        lineHeight: 0,
        textAlign: 'center',
        textTransform: 'none',
        verticalAlign: '-0.125em',
        textRendering: 'optimizeLegibility',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        ...style,
      }}
    >
      <svg
        viewBox="0 0 24 24"
        width="1em"
        height="1em"
        fill="currentColor"
        aria-hidden="true"
        focusable="false"
      >
        <path 
          fillRule="evenodd" 
          d="M12 2.75a9.25 9.25 0 1 0 0 18.5a9.25 9.25 0 0 0 0-18.5M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12S17.937 22.75 12 22.75S1.25 17.937 1.25 12m9.912-5.75H13.5a3.25 3.25 0 0 1 0 6.5h-2.75v.5H12a.75.75 0 0 1 0 1.5h-1.25V17a.75.75 0 0 1-1.5 0v-2.25H9a.75.75 0 0 1 0-1.5h.25v-.5H9a.75.75 0 0 1 0-1.5h.25V8.162c0-.146 0-.297.022-.436a1.75 1.75 0 0 1 1.454-1.454c.139-.022.29-.022.435-.022m-.412 5h2.75a1.75 1.75 0 1 0 0-3.5h-2.3a8.208 8.208 0 0 0-.24.003a.25.25 0 0 0-.207.206l-.002.043a8.1 8.1 0 0 0-.001.198z" 
          clipRule="evenodd"
        />
      </svg>
    </span>
  );
};

